import { render, staticRenderFns } from "./AddStudentModal.vue?vue&type=template&id=630077b8&scoped=true"
import script from "./AddStudentModal.vue?vue&type=script&lang=js"
export * from "./AddStudentModal.vue?vue&type=script&lang=js"
import style0 from "./AddStudentModal.vue?vue&type=style&index=0&id=630077b8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "630077b8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('630077b8')) {
      api.createRecord('630077b8', component.options)
    } else {
      api.reload('630077b8', component.options)
    }
    module.hot.accept("./AddStudentModal.vue?vue&type=template&id=630077b8&scoped=true", function () {
      api.rerender('630077b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/course/components/AddStudentModal.vue"
export default component.exports